module.exports = __webpack_public_path__ + "static/img/weiguanwang3.5700211.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weiguanwang3.png
// module id = 1xkH
// module chunks = 52